import {
  Avatar,
  Paragraph,
  Text,
  XStack,
  YStack,
} from '@bounty/creators-design-system'
import { format } from 'date-fns'
import { MessagePartsFragment } from '../../generated/backendGraphql'
import BountyBrandmark from '../../assets/bounty-brandmark.png'

export type MessageItemProps = {
  userId: string
  item: MessagePartsFragment
}

export const ReceivedMessageItem = ({ item }: MessageItemProps) => {
  return (
    <XStack pb="$2" flexShrink={1}>
      <XStack mr="$2">
        <Avatar size={24} src={item.sender.avatarUrl ?? BountyBrandmark} />
      </XStack>
      <YStack width={265} flexShrink={1}>
        <XStack p={10} borderRadius={'$4'} backgroundColor="$neutral.200">
          {/* width: 100% needed to fix an iOS Safari bug */}
          <Paragraph whiteSpace="pre-wrap" width={'100%'}>
            {item.message}
          </Paragraph>
        </XStack>
        <Text color="$neutral.600" size={'$xs'}>
          {format(new Date(item.sentAt), 'K:mm a')}
        </Text>
      </YStack>
    </XStack>
  )
}

export const SystemMessageItem = ({ item }: MessageItemProps) => {
  return (
    <XStack pb="$2" justifyContent="center">
      <Paragraph
        maxWidth={250}
        textAlign="center"
        color="$neutral.600"
        size="$sm"
      >
        {item.message}
      </Paragraph>
    </XStack>
  )
}

export const UserMessageItem = ({ item }: MessageItemProps) => {
  return (
    <XStack pb="$2" justifyContent="flex-end">
      <YStack alignItems="flex-end">
        <XStack
          maxWidth={250}
          p={10}
          borderRadius={'$4'}
          backgroundColor="rgba(92, 225, 230, 1)"
        >
          {/* width: 100% needed to fix an iOS Safari bug */}
          <Paragraph whiteSpace="pre-wrap" width={'100%'} color="$neutral.50">
            {item.message}
          </Paragraph>
        </XStack>
        <Text color="$neutral.600" size={'$xs'}>
          {format(new Date(item.sentAt), 'K:mm a')}
        </Text>
      </YStack>
    </XStack>
  )
}

export const MessageItem = (props: MessageItemProps) => {
  if (props.item.isSystem) {
    return <SystemMessageItem {...props} />
  }

  return props.item.sender.id === props.userId ? (
    <UserMessageItem {...props} />
  ) : (
    <ReceivedMessageItem {...props} />
  )
}
